export function maskCreditCardNumber(length, lastFour) {
  return formatCreditCardNumber("•".repeat(length - 4) + lastFour);
}

export function formatCreditCardNumber(cardNumber) {
  switch (cardNumber.length) {
    case 14:
    case 15:
      // xxxx xxxxxx xxxx(x)
      return insertSpaces(cardNumber, [4, 10]);
    case 16:
      // xxxx xxxx xxxx xxxx
      return insertSpaces(cardNumber, [4, 8, 12]);
    default:
      return cardNumber;
  }
}

function insertSpaces(str, indices) {
  const result = [];
  for (let i = indices.length - 1; i >= 0; i--) {
    const [start, end] = splitAt(str, indices[i]);
    result.unshift(end);
    str = start;
  }
  result.unshift(str);
  return result.join(" ");
}

function splitAt(str, index) {
  return [str.substring(0, index), str.substring(index)];
}
